import { Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import QuestionCircleOutlined from '@/comp/common/icons/QuestionCircleOutlined';
import { ImageTagsDrawer } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/MobileUploadWizzard/components/ImagePreviewMobile/components';

const UploadPicturesMobile = observer(() => {
  const { t } = useTranslation();
  const [isImageTagsDrawerOpen, setIsImageTagsDrawerOpen] = useState(false);

  const openImageTagsDrawer = () => setIsImageTagsDrawerOpen(true);
  const closeCompressorDrawer = () => setIsImageTagsDrawerOpen(false);

  return (
    <div className="image-list-header">
      <Button
        type="text"
        className="open-image-tags-drawer-btn"
        icon={<QuestionCircleOutlined />}
        onClick={openImageTagsDrawer}
      >
        {t('uploadImageMobilePreviewHelperText')}
      </Button>
      <ImageTagsDrawer open={isImageTagsDrawerOpen} onClose={closeCompressorDrawer} />
    </div>
  );
});

export default UploadPicturesMobile;
